var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"width":"100%","height":"100%"}},[_c('SurveyList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }